<div class="result-calendar">
    <div class="month-switch d-flex justify-content-end mb-2">
        <div class="d-flex align-items-baseline justify-content-end">
            <div class="btn btn-sm btn-link " name="today" mwlCalendarPreviousView [view]="view"
                 [(viewDate)]="viewDate">
                <svg width="8" height="13" viewBox="0 0 8 13" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.5 11.2686L1.5 6.26855L6.5 1.26855" stroke="#10082F" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="currentView" mwlCalendarToday [(viewDate)]="viewDate">
                {{ viewDate | calendarDate:(view + 'ViewTitle'):locale }}
            </div>
            <div class="btn btn-sm btn-link" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate">
                <svg width="8" height="13" viewBox="0 0 8 13" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.5 11.2686L6.5 6.26855L1.5 1.26855" stroke="#10082F" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
    </div>
    <mwl-calendar-month-view
            [headerTemplate]="headerTemplate"
            [cellTemplate]="customCellTemplate"
            [viewDate]="viewDate"
            [locale]="locale"
            (dayClicked)="onDayClick($event.day)"
            [events]="events">
    </mwl-calendar-month-view>
</div>
<ng-template #customCellTemplate let-day="day" let-locale="locale">
    <div class="cal-cell-top">
        <div class="actions-wrapper" *ngIf="day.events.length > 0">
            <div *ngFor="let event of day.events; index as i">
                <div class="cal-events"
                     [ngStyle]="{background: generateCircle(event.color)}"
                     [ngClass]="{'small' : day.events.length > 2}">
                </div>
            </div>
        </div>
        <span class="cal-day-number"
              [ngClass]="{'active': isActiveDate(day)}">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
    </div>
    <div class="cal-events-select actions-wrapper d-flex flex-column"
         *ngIf="day.events.length > 1 && showSelector === day.date">
        <div class="d-flex align-items-center justify-content-between">
            <button class="btn btn-back btn-link text-secondary" (click)="showCalendar($event)">
                <svg width="8" height="13" viewBox="0 0 8 13" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.5 11.2686L1.5 6.26855L6.5 1.26855" stroke="#10082F" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <h3>{{day.date | date : 'dd MMMM' }}</h3>
        </div>
        <p>Оберіть замір</p>
        <div class="events-wrapper">
            <div class="event-wrapper" *ngFor="let event of day.events; index as i">
                <div class="text-muted">{{event.start | date: 'HH:mm'}}</div>
                <button class=" btn btn-primary link hover_action border-0 " [disabled]="this.currentSession === event.id"
                        (click)="onSelect(event.id)" >

                    Результат заміру {{translateTestName(event.title)}}
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 13L7 7L1 1" stroke="white" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>

                </button>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #headerTemplate let-days="days" let-locale="locale">
    <div class="d-flex custom-header">
        <span class="flex-grow-1" *ngFor="let day of days">{{getWeekDay(day.day)}}</span>
    </div>
</ng-template>
